/* Rally cart-drawer HIGH DEMAND timer.
   Globally-loaded, idempotent. Counts down from 10:00 per browser-session
   (sessionStorage), updates all [data-rly-cart-timer] bars in DOM every
   second, and hides them when expired. Tolerant van Horizon's section
   morphs — we re-query DOM op elke tick zodat verse markup direct sync't. */
(function () {
  if (window.__rlyCartTimerInit) return;
  window.__rlyCartTimerInit = true;

  var STORAGE_KEY = 'rlyCartTimerExpiresAt';
  var DURATION_MS = 10 * 60 * 1000; // 10 minutes

  function getDeadline() {
    var stored = 0;
    try { stored = parseInt(sessionStorage.getItem(STORAGE_KEY) || '0', 10); } catch (_) {}
    var now = Date.now();
    if (!stored || stored < now) {
      stored = now + DURATION_MS;
      try { sessionStorage.setItem(STORAGE_KEY, stored.toString()); } catch (_) {}
    }
    return stored;
  }

  var deadline = getDeadline();

  function fmt(ms) {
    var totalSec = Math.max(0, Math.ceil(ms / 1000));
    var min = Math.floor(totalSec / 60);
    var sec = totalSec % 60;
    return (min < 10 ? '0' : '') + min + ':' + (sec < 10 ? '0' : '') + sec;
  }

  function update() {
    var bars = document.querySelectorAll('[data-rly-cart-timer]');
    if (!bars.length) return;
    var msLeft = deadline - Date.now();
    if (msLeft <= 0) {
      bars.forEach(function (b) { b.hidden = true; });
      return;
    }
    var txt = fmt(msLeft);
    bars.forEach(function (b) {
      b.hidden = false;
      var t = b.querySelector('[data-rly-cart-timer-time]');
      if (t && t.textContent !== txt) t.textContent = txt;
    });
  }

  update();
  setInterval(update, 1000);
})();
